import Vue from 'vue'
import A7LoginSimples from './A7LoginSimples'

const LoginSimples = {
  show(component) {
    const A7LoginSimplesCtor = Vue.extend(A7LoginSimples)
    const newEl = document.createElement('div')
    component.$el.append(newEl)
    const A7LoginSimplesInstance = new A7LoginSimplesCtor({
      el: newEl,
      router: component.$router
    })
  }
}

export default LoginSimples
